import { delay, get, post } from '../../utils/http';
import dashboardFinancial from '../mock/dashboardFinancial.json';

export const fetchUser = () => get('/auth/me');

export const fetchFileTypes = () => get('/documents/types');

export const uploadExpense = () => delay({ data: { path: 'test.doc' } });

export const fetchRegions = () => get('/regions');

export const fetchModules = () => get('/modules');

export const fetchIndustries = () => get('/industries');

export const fetchBiTypes = () => get('/bi-types');

export const fetchJobTypes = () => get('/jobs/types');

export const fetchEmploymentTypes = () => get('/employment-types');

export const fetchRoles = () => get('/roles');

export const fetchPrivileges = () => get('/privileges');

export const fetchReports = () => get('/reports');

export const fetchReportCategories = () => get('/categories');

export const postAction = () => delay({});

export const fetchFinancial = () => delay(dashboardFinancial);

export const fetchPayrollPeriods = () => get('/payroll-period-types');

export const fetchRequestsTypes = () => get('/requests/types');

export const fetchGenericIntegrations = () => get('/integrations');

export const fetchPlans = () => get(`/plans`);

export const integrationsOAuth2ExchangeCode = (integrationId, code) =>
  post(`/integrations/${integrationId}/code-exchange`, { code });

export const uploadImage = (files) => {
  const formData = new FormData();
  formData.append('file', files[0]);
  return post(`/upload`, formData, { 'Content-Type': 'multipart/form-data' });
};
